import axios, {
	AxiosError,
	AxiosResponse,
	InternalAxiosRequestConfig,
} from 'axios';

const TOKEN_KEY = 'libro_admin_token';

const AUTH_ERROR_CODES = {
	VERSION_MISMATCH: 1,
	TOKEN_EXPIRED: 2,
	INVALID_TOKEN: 3,
	TOKEN_REQUIRED: 4,
} as const;

const apiClient = axios.create({
	baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000',
	timeout: 60_000,
	headers: {
		'Content-Type': 'application/json',
	},
});

apiClient.interceptors.request.use(
	(config: InternalAxiosRequestConfig) => {
		const token = localStorage.getItem(TOKEN_KEY);
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

apiClient.interceptors.response.use(
	(response: AxiosResponse) => {
		if (response.data?.success === false) {
			if (
				typeof response.data?.code === 'number' &&
				Object.values(AUTH_ERROR_CODES).includes(
					response.data.code,
				)
			) {
				localStorage.removeItem(TOKEN_KEY);
				if (window.location.pathname !== '/login') {
					window.location.href = '/login';
				}
			}
			return Promise.reject(
				new Error(
					response.data.message ||
						'Error en la solicitud',
				),
			);
		}
		return response;
	},
	(error: AxiosError) => {
		if (error.response) {
			switch (error.response.status) {
				case 401:
					localStorage.removeItem(TOKEN_KEY);
					if (
						window.location.pathname !== '/login'
					) {
						window.location.href = '/login';
					}
					break;
				case 404:
					console.error('Resource not found');
					break;
				case 500:
					console.error('Server error');
					break;
			}
		} else if (error.request) {
			console.error('No response from server');
		} else {
			console.error('Request error:', error.message);
		}
		return Promise.reject(error);
	},
);

export default apiClient;
